"use client"

import { ComponentConfig } from "@measured/puck"
import { RenderConfig, StoreInfoProps } from "./RenderConfig"

export const StoreInfo: ComponentConfig<StoreInfoProps> = {
    label: "Tamda Foods | Store Info",
    fields: {
        title: {
            label: "Title",
            type: "text",
        },
        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {
        title: "DANH SÁCH CỬA HÀNG TDF",
        className: "",
    },
    ...RenderConfig,
}
